// extracted by mini-css-extract-plugin
export var grid = "fp-pW";
export var gridWithRowGap = "fp-qW";
export var maxWidthContainer = "fp-uW";
export var mobileLanguageSelector__item = "fp-vW";
export var mobileLanguageSelector__itemFocus = "fp-oW";
export var mobileLanguageSelector__itemSelected = "fp-wW";
export var mt0 = "fp-hW";
export var mt1 = "fp-iW";
export var mt2 = "fp-jW";
export var mt3 = "fp-kW";
export var mt4 = "fp-lW";
export var mt5 = "fp-mW";
export var mt6 = "fp-nW";
export var removeVisuallyHidden = "fp-sW";
export var visuallyHidden = "fp-rW";
export var widgetBase = "fp-tW";